// extracted by mini-css-extract-plugin
module.exports = {"bgStep":"styles_bgStep__3pYMG","iconDownStep":"styles_iconDownStep__KtXVS","overlayStep":"styles_overlayStep__PzdTf"};